import { lazy, Suspense } from "react";
import { Loading } from "@/components/Loading";
import { useRuntimeConfiguration } from "@/contexts/runtimeConfigurationProvider";

const FbaccountApp = lazy(() => import("./routes/fbaccountRoutes"));
const BackofficeApp = lazy(() => import("./routes/backofficeRoutes"));

export default function AppContent() {
  const { appRole } = useRuntimeConfiguration();
  const RoleApp = appRole === "backoffice" ? BackofficeApp : FbaccountApp;

  return (
    <Suspense fallback={<Loading />}>
      <RoleApp />
    </Suspense>
  );
}
